import type { PracticeScenario, PracticeStatus } from './types';

const STATUS_TIER: Record<PracticeStatus, number> = { new: 0, seen: 1, completed: 2 };

/**
 * Новые → непройденные → пройденные. Сортировка стабильна (`Array.sort`
 * гарантированно stable в движках, которые мы поддерживаем), поэтому порядок
 * внутри каждого уровня остаётся таким, какой пришёл с бэка (по `orderIndex`).
 */
export function sortByStatusTier(scenarios: PracticeScenario[]): PracticeScenario[] {
  return [...scenarios].sort((a, b) => STATUS_TIER[a.status] - STATUS_TIER[b.status]);
}

/**
 * То же деление на уровни, что и `sortByStatusTier`, но порядок внутри
 * каждого уровня — случайный. На главном экране показываем не весь список
 * (см. `widgets/topics`), а перемешивание внутри уровня увеличивает шанс,
 * что со временем пользователь увидит разные карточки, а не всегда одни и те
 * же первые по `orderIndex`.
 */
export function shuffleByStatusTier(scenarios: PracticeScenario[]): PracticeScenario[] {
  const tiers: Record<PracticeStatus, PracticeScenario[]> = { new: [], seen: [], completed: [] };
  for (const scenario of scenarios) tiers[scenario.status].push(scenario);
  return [...shuffle(tiers.new), ...shuffle(tiers.seen), ...shuffle(tiers.completed)];
}

function shuffle<T>(items: T[]): T[] {
  const copy = [...items];
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const tmp = copy[i]!;
    copy[i] = copy[j]!;
    copy[j] = tmp;
  }
  return copy;
}
